import BasicLoadable from "@ovrsea/ovrlib/components/Loadable/BasicLoadable";

export const LoadablePreloader = BasicLoadable({
  loader: () => import("./Preloader"),
  loading: null,
});
